<div mat-dialog-title color="primary">CREATE QUIZ VIDEO</div>
<lib-toastify-toast-container position="bottom-right"></lib-toastify-toast-container>
<div mat-dialog-content class="dialog-content" style="align-items: center">
  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Statement</mat-label>
      <input matInput [formControl]="statementControl" />
      <button *ngIf="statementControl.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="statementControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="statementControl.hasError('required')">
        Statement is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Right Answer</mat-label>
      <input matInput [formControl]="rightAnswerControl" />
      <button *ngIf="rightAnswerControl.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="rightAnswerControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="rightAnswerControl.hasError('required')">
        Right Answer is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Wrong Answer 1</mat-label>
      <input matInput [formControl]="wrongAnswerControl" />
      <button *ngIf="wrongAnswerControl.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="wrongAnswerControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="wrongAnswerControl.hasError('required')">
        Wrong Answer 1 is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Wrong Answer 2</mat-label>
      <input matInput [(ngModel)]="data.wrongAnswers[1]" />
      <button *ngIf="data.wrongAnswers[1]" matSuffix mat-icon-button aria-label="Clear"
        (click)="data.wrongAnswers[1] = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Wrong Answer 3</mat-label>
      <input matInput [(ngModel)]="data.wrongAnswers[2]" />
      <button *ngIf="data.wrongAnswers[2]" matSuffix mat-icon-button aria-label="Clear"
        (click)="data.wrongAnswers[2] = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Difficulty</mat-label>
      <mat-select [(ngModel)]="data.difficulty">
        <ng-container *ngFor="let difficulty of difficulties">
          <mat-option [value]="difficulty">{{difficulty}}</mat-option>
        </ng-container>
      </mat-select>
      <button *ngIf="data.difficulty" matSuffix mat-icon-button aria-label="Clear"
        (click)="data.difficulty = 1">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Is Grammar?</mat-label>
      <mat-select [formControl]="grammarControl">
        <mat-option [value]="false">No</mat-option>
        <mat-option [value]="true">Yes</mat-option>
      </mat-select>
      <mat-error *ngIf="grammarControl.hasError('required')">
        Grammar is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Start Seconds</mat-label>
      <input matInput type="number" [(ngModel)]="data.videoStart" />
      <button *ngIf="data.videoStart" matSuffix mat-icon-button aria-label="Clear" (click)="data.videoStart = 0">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-container>

  <ng-container class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>End Seconds</mat-label>
      <input matInput type="number" [formControl]="videoEndControl" />
      <button *ngIf="videoEndControl.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="videoEndControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="videoEndControl.hasError('required')">
        End Seconds is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="image-content">
    <mat-form-field appearance="outline">
      <mat-label>Video Link</mat-label>
      <input matInput (ngModelChange)="changeVideo($event)" [formControl]="videoIdControl" />
      <button *ngIf="videoIdControl.value" matSuffix mat-icon-button aria-label="Clear"
        (click)="videoIdControl.reset()">
        <mat-icon>close</mat-icon>
      </button>
      <mat-error *ngIf="videoIdControl.hasError('required')">
        Video Link is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container class="image-content" *ngIf="data.videoId">
    <iframe [src]="createVideo(data.videoId)" frameborder="0" allowfullscreen></iframe>
  </ng-container>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()">Discard</button>
  <button mat-button (click)="createQuizVideo()" cdkFocusInitial>Save</button>
</div>